import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const StripeCheckoutTable = ({
  invoices,
  isLoading,
  isGenerating,
  formatCurrency,
  formatDateTime,
  statusColor,
  onGenerate,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between">
          <Heading size="sm">Stripe Checkout</Heading>
          <Text fontSize="sm" color="gray.500">
            {invoices.length} records
          </Text>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : invoices.length === 0 ? (
          <EmptyState title="No unpaid invoices" description="All invoices are paid or none exist yet." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Invoice</Th>
                  <Th>Customer</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Created</Th>
                  <Th></Th>
                </Tr>
              </Thead>
              <Tbody>
                {invoices.map((invoice) => (
                  <Tr key={invoice.id}>
                    <Td>{invoice.invoiceNumber || `#${invoice.id}`}</Td>
                    <Td>{invoice.customerEmail}</Td>
                    <Td isNumeric>{formatCurrency(invoice.amount, invoice.currency)}</Td>
                    <Td>
                      <Badge colorScheme={statusColor(invoice.status)}>{invoice.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(invoice.createdDate)}</Td>
                    <Td>
                      <Button
                        size="xs"
                        colorScheme="blue"
                        variant="outline"
                        onClick={() => onGenerate(invoice)}
                        isLoading={isGenerating}
                        isDisabled={String(invoice.status || "").toUpperCase() === "PAID"}
                      >
                        Generate
                      </Button>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default StripeCheckoutTable;
